import { getClientDispatcher } from '@atlassian/jira-s2c-client-dispatcher/src/singleton.tsx';
import { CLIENT_DISPATCHER_MODULE } from '@atlassian/jira-s2c-client-dispatcher/src/constants.tsx';
import { SERVER_STREAM_ENDED } from './constants.tsx';
import { ClientReceiver } from './index.tsx';

let receiver: ClientReceiver;

export function getClientReceiver() {
	// special-case: if server, bail early and do nothing
	if (__SERVER__ || !globalThis.document) {
		return;
	}
	if (!receiver) {
		const dispatcher = getClientDispatcher();
		const sink = dispatcher.ingest.bind(dispatcher);
		receiver = new ClientReceiver(globalThis.document, sink);
		receiver.fulfilled().then(() => {
			sink({
				id: CLIENT_DISPATCHER_MODULE,
				name: '_abort',
				args: [{ reason: SERVER_STREAM_ENDED }],
			});
		});
	}
	return receiver;
}
